import React from "react";
import { CheckCircle2, MapPin, ShieldCheck } from "lucide-react";
import PageHeader from "../components/PageHeader";
import ServicesGrid from "../components/ServicesGrid";
import CTABanner from "../components/CTABanner";
import WhyChooseUs from "../components/WhyChooseUs";
import Tarieven from "../components/Tarieven";
import ITSupportTeaser from "../components/ITSupportTeaser";

const Diensten = () => {
  return (
    <>
      <PageHeader
        eyebrow="— Reparatieservice"
        title="Computer- en laptopreparatie in Beverwijk en omgeving"
        subtitle="Snelle, eerlijke computerhulp in Beverwijk: virus verwijderen, data herstel, netwerkproblemen en laptop reparatie. Gratis diagnose, transparante prijzen vanaf €45."
      />

      {/* SEO-rich intro section */}
      <section className="py-16 bg-white">
        <div className="max-w-[1280px] mx-auto px-5 md:px-10">
          <div className="grid lg:grid-cols-[1.3fr_1fr] gap-12 items-start">
            <div>
              <p className="text-sm tracking-[0.3em] uppercase text-neutral-500 mb-3">— Wat wij doen</p>
              <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-5 leading-tight">
                Computerhulp in <span className="italic font-light">Beverwijk</span> — voor iedereen.
              </h2>
              <div className="text-neutral-700 space-y-4 leading-relaxed">
                <p>
                  Computheer is uw lokale specialist voor <strong>computer reparatie in Beverwijk</strong> en de hele IJmond.
                  Al meer dan 15 jaar helpen wij particulieren én bedrijven met alles rondom computers, laptops en netwerken —
                  vakkundig, eerlijk en zonder verborgen kosten.
                </p>
                <p>
                  Of het nu gaat om een <strong>laptop reparatie</strong>, een virus verwijderen, een <strong>data herstel</strong> na een crash,
                  of een gewoon te trage PC — wij bieden een gratis diagnose en altijd een duidelijke prijsopgave vooraf.
                  U betaalt dus nooit voor onderzoek als u besluit niet te repareren.
                </p>
                <p>
                  Wij komen ook aan huis: in <strong>Beverwijk, Heemskerk, Velsen, IJmuiden, Wijk aan Zee, Uitgeest en Castricum</strong>
                  brengen wij geen voorrijkosten in rekening. Liever niet wachten? Kies dan voor{" "}
                  <a href="/hulp-op-afstand" className="underline font-medium">hulp op afstand</a> — u wordt direct geholpen zonder de deur uit te hoeven.
                </p>
              </div>
              <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-2.5">
                {[
                  "Computer reparatie & upgrade",
                  "Laptop reparatie (scherm, accu, toetsenbord)",
                  "Virus & malware verwijderen",
                  "Data herstel na crash",
                  "Netwerkproblemen & WiFi",
                  "Windows / macOS herinstallatie",
                ].map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-neutral-800">
                    <CheckCircle2 size={17} className="text-emerald-600 shrink-0 mt-0.5"/>
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
            </div>

            <aside className="bg-neutral-50 border border-neutral-200 p-6 md:p-7 space-y-5">
              <div className="flex items-start gap-3">
                <ShieldCheck size={22} className="text-neutral-900 shrink-0 mt-0.5"/>
                <div>
                  <p className="font-semibold text-neutral-900 mb-0.5">3 maanden garantie</p>
                  <p className="text-sm text-neutral-600">Op elke reparatie. Terugkerend probleem? Wij lossen het kosteloos op.</p>
                </div>
              </div>
              <div className="flex items-start gap-3 pt-5 border-t border-neutral-200">
                <MapPin size={22} className="text-neutral-900 shrink-0 mt-0.5"/>
                <div>
                  <p className="font-semibold text-neutral-900 mb-0.5">Gratis aan huis in IJmond</p>
                  <p className="text-sm text-neutral-600">Beverwijk, Heemskerk, Velsen, IJmuiden, Uitgeest, Castricum en omgeving.</p>
                </div>
              </div>
              <div className="pt-5 border-t border-neutral-200">
                <p className="text-xs uppercase tracking-widest text-neutral-500 mb-1">Vanaf</p>
                <div className="flex items-baseline gap-2">
                  <span className="text-3xl font-bold text-neutral-900">€45</span>
                  <span className="text-sm text-neutral-500">voor kleine reparaties</span>
                </div>
                <p className="text-xs text-neutral-500 mt-1">Gratis diagnose, altijd vooraf een prijsopgave.</p>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <ServicesGrid compact />
      <ITSupportTeaser variant="diensten" />
      <Tarieven />
      <WhyChooseUs />
      <CTABanner />
    </>
  );
};

export default Diensten;
